module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAA1UlEQVQ4ja3U0W3CMBQF0NOIBVihK4QRygh0BBgBRoARmr98M0JZISuwQlbgw7YUDCQ47ZWiSEl0bD/75aNtW9jjy316NLgozALHiD7LButSuBoBU+oSkDDTqWw9lialxwHXUvQzXmPvV8MH1RvoVOp80P9A5eir5fc4y2o1ksmanrGL8FQ9U4bfdTnaRHAjnN93wDzXIdpFcIufGVjKKW1UJ3ROHWc4G0RTCbXbYYnfeJ+TRmgEC3wLu/cXsEtgQi8RLO7xAbgWVoxw+JczwfRrvAPhBsedKIAGrZGUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/folder.png
// module id = 730
// module chunks = 0